import React from 'react';
import { Checkbox as RoccoCheckbox } from '@rocco/components/checkbox';
import { Label as RoccoLabel } from '@rocco/components/label';
import { useFiltersContext } from '@rocco/ui/filter-sort/components/Filters';
import type { FilterConfigModalItemMultiple } from '@rocco/ui/filter-sort/types/filter-config-modal';
import type { MultipleValuesFilterState } from '@rocco/ui/filter-sort/view-models/filter-state/multiple-values-filter-state';
import type { FilterModalElementProps } from '@rocco/ui/filter-sort/components/filters-modal/FiltersModalElement';

export const FiltersModalMultipleValues = (
    props: FilterModalElementProps<
        FilterConfigModalItemMultiple,
        MultipleValuesFilterState
    >,
) => {
    const { filterConfigItem, filterState, onFilterStateUpdate } = props;
    const {
        searchFilters: { handleToggleMultipleValues },
    } = useFiltersContext();

    const columns = filterConfigItem.columns > 0 ? filterConfigItem.columns : 1;
    const containerStyles = {
        gridTemplateColumns: `repeat(${columns}, 1fr)`,
        gridTemplateRows: `repeat(${Math.ceil(filterState.items.length / columns)}, auto)`,
    };

    return (
        <div
            className="grid grid-flow-col-dense gap-2 pt-4"
            style={containerStyles}
        >
            {filterState.items.map((item) => (
                <div
                    key={`${filterConfigItem.filterKey}-${item.value}`}
                    className="flex items-center justify-between"
                >
                    <RoccoLabel
                        htmlFor={`${filterConfigItem.filterKey}-${item.value}`}
                        target="checkboxReversed"
                    >
                        {item.label}
                    </RoccoLabel>

                    <RoccoCheckbox
                        id={`${filterConfigItem.filterKey}-${item.value}`}
                        checked={item.checked}
                        onCheckedChange={(checked) => {
                            if (handleToggleMultipleValues) {
                                onFilterStateUpdate(
                                    handleToggleMultipleValues(
                                        filterState,
                                        item,
                                        !!checked,
                                    ),
                                );
                            }
                        }}
                    />
                </div>
            ))}
        </div>
    );
};
